import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePatient } from "@/context/PatientContext";
import { EnvelopeSimple, Check, X } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function InvitesBanner() {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const { reload: reloadPatients, setActiveId } = usePatient();

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/invites");
      setInvites(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const accept = async (inv) => {
    try {
      const { data } = await api.post(`/invites/${inv.invite_code}/accept`);
      toast.success(`You now have access to ${inv.patient_name}`);
      await reloadPatients();
      if (data.patient_id) setActiveId(data.patient_id);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Accept failed");
    }
  };
  const decline = async (inv) => {
    await api.post(`/invites/${inv.invite_code}/decline`);
    toast.success("Invite declined");
    load();
  };

  if (loading || invites.length === 0) return null;

  return (
    <div className="bg-white border-2 border-[#2C5545]/30 rounded-2xl p-5 mb-6" data-testid="invites-banner">
      <div className="flex items-center gap-2 mb-3">
        <EnvelopeSimple size={22} weight="duotone" className="text-[#2C5545]" />
        <h3 className="font-heading text-lg font-bold">You have {invites.length} pending invite{invites.length > 1 ? "s" : ""}</h3>
      </div>
      <div className="space-y-2">
        {invites.map((inv) => (
          <div key={inv.id} data-testid={`invite-row-${inv.id}`} className="rounded-xl bg-[#FDFBF7] p-4 flex items-center flex-wrap gap-3">
            <div className="flex-1 min-w-0">
              <div className="font-semibold">
                <span className="text-[#576A62]">{inv.owner_name || inv.owner_email}</span> invited you to help care for{" "}
                <span className="text-[#2C5545]">{inv.patient_name}</span>
              </div>
              <div className="text-xs text-[#576A62] mt-0.5">Role: <span className="font-medium">{inv.role}</span></div>
            </div>
            <button
              onClick={() => accept(inv)}
              data-testid={`invite-accept-${inv.id}`}
              className="rounded-full bg-[#2C5545] hover:bg-[#224235] text-white text-sm font-semibold px-4 py-2 inline-flex items-center gap-1"
            >
              <Check size={16} weight="bold" /> Accept
            </button>
            <button
              onClick={() => decline(inv)}
              data-testid={`invite-decline-${inv.id}`}
              className="rounded-full border border-[#EBE8E0] text-[#576A62] hover:bg-[#EBE8E0]/60 text-sm px-4 py-2 inline-flex items-center gap-1"
            >
              <X size={16} /> Decline
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
